import { memo, useCallback } from "react";

import { Dropdown } from "ui/components/Dropdown/Dropdown";
import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";

import {
  CRON_JOB_EXECUTION_STATUS_OPTIONS,
  initialCronJobExecutionSearchForm,
} from "services/api/cronjobs/consts";
import { CronJobExecutionSearchFormValues } from "services/api/cronjobs/types";

interface CronJobExecutionsFiltersProps {
  formValues: CronJobExecutionSearchFormValues;
  onSearchChange: (values: CronJobExecutionSearchFormValues) => void;
}

const CronJobExecutionsFilters: React.FC<CronJobExecutionsFiltersProps> = (props) => {
  const { formValues, onSearchChange } = props;

  const handleStatusChange = useCallback(
    (_e: any, _name: string, item: DropdownOption) => {
      onSearchChange({ ...formValues, status: item.value ?? "" });
    },
    [formValues, onSearchChange]
  );

  const handleResetFormClick = useCallback(() => {
    onSearchChange(initialCronJobExecutionSearchForm);
  }, [onSearchChange]);

  return (
    <div className="flex flex-wrap items-center gap-3">
      <Dropdown
        name="status"
        value={formValues.status}
        options={CRON_JOB_EXECUTION_STATUS_OPTIONS}
        onChange={handleStatusChange}
        placeholder="Svi statusi"
        width="small"
        cssClassName="bg-white"
      />
      <span
        onClick={handleResetFormClick}
        className="text-xs font-bold cursor-pointer text-gray-700"
      >
        Poništi
      </span>
    </div>
  );
};

export default memo(CronJobExecutionsFilters);
